// It exports, as default, the reducer function.
// It exports, as named export, the selectors and the operations as needed.
// Optionally, it exports the types if they are needed in other ducks (other redux folders).

import reducer from "./reducers";
import applicationOperations from "./operations";

export { applicationOperations };
export default reducer;
